import { truckApi } from './truckApi'

async function getById(truckId: string) {
  const truck = truckApi.getById(truckId)
  return truck
}

export const truckServices = { getById }
